// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Form = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Form = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Form = _exports.Form = function Form(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13.4375 2.5H15C16.3789 2.5 17.5 3.62109 17.5 5V17.5C17.5 18.8789 16.3789 20 15 20H5C3.62109 20 2.5 18.8789 2.5 17.5V5C2.5 3.62109 3.62109 2.5 5 2.5H6.5625H6.9375C7.22656 1.07422 8.48828 0 10 0C11.5117 0 12.7734 1.07422 13.0625 2.5H13.4375ZM5 4.375C4.65625 4.375 4.375 4.65625 4.375 5V17.5C4.375 17.8438 4.65625 18.125 5 18.125H15C15.3438 18.125 15.625 17.8438 15.625 17.5V5C15.625 4.65625 15.3438 4.375 15 4.375H14.375V5.3125C14.375 5.83203 13.957 6.25 13.4375 6.25H10H6.5625C6.04297 6.25 5.625 5.83203 5.625 5.3125V4.375H5ZM10 4.0625C10.2486 4.0625 10.4871 3.96373 10.6629 3.78791C10.8387 3.6121 10.9375 3.37364 10.9375 3.125C10.9375 2.87636 10.8387 2.6379 10.6629 2.46209C10.4871 2.28627 10.2486 2.1875 10 2.1875C9.75136 2.1875 9.5129 2.28627 9.33709 2.46209C9.16127 2.6379 9.0625 2.87636 9.0625 3.125C9.0625 3.37364 9.16127 3.6121 9.33709 3.78791C9.5129 3.96373 9.75136 4.0625 10 4.0625Z",
      fill: "currentColor"
    }));
  };
});
